import personelimg from "src/img/tabs/personel.png";
import contactsimg from "src/img/tabs/contacts.png";
import organizationsimg from "src/img/tabs/organizations.png";
import timecardimg from "src/img/tabs/timeCard.png";
import workordersimg from "src/img/tabs/projects.png";
import tasksimg from "src/img/tabs/tasks.png";
import { User } from "./authStore";
import { Navigate, Outlet, ShouldRevalidateFunctionArgs } from "react-router-dom";

import { deleteOrganizationAction, organizationExportAction, organizationAction, organizationLoader, organizationsLoader, validateOrganizationAction, voidOrganizationAction } from "../organizations/actions_loaders";
import OrganizationList from "src/components/organizations/OrganizationList";
import OrganizationDetail from "../organizations/OrganizationDetail";
import OrganizationForm from "../organizations/OrganizationForm";
import OrganizationFilterForm from "../organizations/OrganizationFilterForm";
import OrganizationExportForm from "../organizations/OrganizationExportForm";

import { contactAction, contactExportAction, contactLoader, contactsLoader, deleteContactAction, validateContactAction, voidContactAction } from "../contacts/actions_loaders";
import ContactList from "src/components/contacts/ContactList";
import ContactFilterForm from "../contacts/ContactFilterForm";
import ContactExportForm from "../contacts/ContactExportForm";
import ContactDetail from "../contacts/ContactDetail";
import ContactForm from "../contacts/ContactForm";

import { deleteWorkOrderAction, generateReqPDF, generateScanPDF, generateStatusPDF, scanLoader, tasksAction, tasksLoader, transitionWorkOrderStatusAction, validatWorkOrderAction, voidWorkOrderAction, workOrderAction, workOrderExportAction, workOrderLoader, workOrderSettingsAction, workOrderSettingsLoader, workOrdersLoader } from "src/components/workOrders/action_loaders";
import WorkOrders from "src/components/workOrders/WorkOrders";
import WorkOrderDetail from "../workOrders/WorkOrderDetail";
import WorkOrderForm from "../workOrders/WorkOderForm";
import WorkOrderFilterForm from "../workOrders/WorkOrderFilterForm";
import WorkOrderExportForm from "../workOrders/WorkOrderExportForm";
import WorkOrderSettingForm from "../workOrders/SettingsForm";
import Tasks from "../workOrders/Tasks";

import TimeCard from "src/components/timeCard/TimeCard";
import { timeCardLoader, timeCardPunch, timeCardUpdateContent, timeCardUpdateTime, timeCardSubmit, timeCardDownload, timeCardExportAction, timeCardRedirectLoader } from "src/components/timeCard/action_loaders";
import { allTimeCardsDetailLoader, allTimeCardsListLoader, allTimeCardsApprovalAction, allTimeCardsUpdateTimeAction } from "../timeCard/action_loaders";
import AllTimeCardsDetail from "../timeCard/AllTimeCardsDetail";
import AllTimeCardsList from "../timeCard/AllTimeCardsList";

import { usersLoader, userLoader, userAction, userExportAction, deleteUserAction, validateUserAction, voidUserAction } from "src/components/users/actions_loaders";
import UserList from "../users/UserList";
import UserForm from "../users/UserForm";
import UserDetail from "../users/UserDetail";
import UserExportForm from "../users/UserExportForm";
import UsersFilterForm from "../users/UserFilterForm";
import BirthDayForm from "../users/BirthdayForm";

const appRoutes = (user:User) => [
    {
        show: true,
        title: "Organizations",
        path: "Organizations",
        img: organizationsimg, 
        children: [
            { 
                path: "", 
                element: <OrganizationList/>, 
                loader: organizationsLoader, 
                children:[
                    { path: "Filter", element: <OrganizationFilterForm/>}, 
                    { path: "Export", element: <OrganizationExportForm/>, children: [{path: "Execute", element: <Outlet/>, action: organizationExportAction}]}, 
                ]
            }, 
            { 
                id: "organization", 
                path: ":id", 
                loader: organizationLoader, 
                shouldRevalidate: ({ actionResult }:ShouldRevalidateFunctionArgs) => {
                    if (actionResult?.duplicate) {
                        return false;
                    }
                    return true;
                }, 
                children: [
                    { index : true, element : <OrganizationDetail/>}, 
                    { path: "Edit", element: <OrganizationForm keyword = "Edit"/>, action: organizationAction}, 
                    { path: "*", element: <Navigate to = ".." replace/>}, 
                    { path: "Delete", element: <Outlet/>, action: deleteOrganizationAction}, 
                    { path: "Void", element: <Outlet/>, action: voidOrganizationAction}, 
                    { path: "Validate", element: <Outlet/>, action: validateOrganizationAction}, 
                ]
            },
            { path: "Add", element: <OrganizationForm keyword = "Add"/>, action: organizationAction}, 
            { path: "*", element: <Navigate to = ".." replace/>}
        ]
    },
    {
        show: true,
        title: "Contacts",
        path: "Contacts",
        img: contactsimg, 
        children: [
            { 
                path: "", 
                element: <ContactList/>, 
                loader: contactsLoader, 
                children:[
                    { path: "Filter", element: <ContactFilterForm/>}, 
                    { path: "Export", element: <ContactExportForm/>, children: [{path: "Execute", element: <Outlet/>, action: contactExportAction}]}, 
                ]
            }, 
            { 
                id: "contact", 
                path: ":id", 
                loader: contactLoader,  
                children: [
                    { index : true, element : <ContactDetail/>}, 
                    { path: "Edit", element: <ContactForm keyword = "Edit"/>, action: contactAction }, 
                    { path: "*", element: <Navigate to = ".." replace/>}, 
                    { path: "Delete", element: <Outlet/>, action: deleteContactAction}, 
                    { path: "Void", element: <Outlet/>, action: voidContactAction}, 
                    { path: "Validate", element: <Outlet/>, action: validateContactAction}, 
                ]
            },
            { path: "Add", element: <ContactForm keyword = "Add"/>, action: contactAction}, 
            { path: "*", element: <Navigate to = ".." replace/>}
        ]
    }, 
    {
        show: true,
        title: "Work Orders",
        path: "WorkOrders",
        img: workordersimg, 
        children: [
            { 
                path: "", 
                element: <WorkOrders/>, 
                loader: workOrdersLoader, 
                children:[
                    { path: "Filter", element: <WorkOrderFilterForm/>}, 
                    { path: "Export", element: <WorkOrderExportForm/>, children: [{path: "Execute", element: <Outlet/>, action: workOrderExportAction}]}, 
                ]
            }, 
            { 
                id: "workOrder", 
                path: ":id", 
                loader: workOrderLoader,  
                children: [
                    { index : true, element : <WorkOrderDetail/>}, 
                    { path: "Edit", element: <WorkOrderForm keyword = "Edit"/>, loader: workOrderSettingsLoader, action: workOrderAction,  
                        children:[
                            { path: "Scan", element: <Outlet/>, loader: scanLoader}, 
                        ]
                    }, 
                    { path: "Delete", element: <Outlet/>, action: deleteWorkOrderAction}, 
                    { path: "Void", element: <Outlet/>, action: voidWorkOrderAction}, 
                    { path: "Validate", element: <Outlet/>, action: validatWorkOrderAction}, 
                    { path: "TransitionStatus", element: <Outlet/>, action: transitionWorkOrderStatusAction},
                    { path: "GenerateStatusPDF", element: <Outlet/>, action: generateStatusPDF}, 
                    { path: "GenerateReqPDF", element: <Outlet/>, action: generateReqPDF}, 
                    { path: "GenerateScanPDF", element: <Outlet/>, action: generateScanPDF}, 
                    { path: "*", element: <Navigate to = ".." replace/>}, 
                ]
            },
            { path: "Add", element: <WorkOrderForm keyword = "Add"/>, loader: workOrderSettingsLoader, action: workOrderAction}, 
            { path: "Settings", element: <WorkOrderSettingForm/>, loader: workOrderSettingsLoader,  action: workOrderSettingsAction }, 
        ]
    },
    {
        show: true,
        title: "Tasks",
        path: "Tasks",
        img: tasksimg, 
        action: tasksAction, 
        element: <Tasks/>, 
        loader: tasksLoader, 
        shouldRevalidate: ({ actionResult }: ShouldRevalidateFunctionArgs): boolean => {
            return actionResult === "revalidate";
        },
    },
    {
        show: user.office === "yes",
        title: "Time Card",
        path: "TimeCard",
        img: timecardimg,
        children: [
            {path: "", element: <TimeCard/>, loader: timeCardRedirectLoader }, 
            {path: ":week", element: <TimeCard/>, loader: timeCardLoader, children: [
                { path: "Punch", element: <Outlet/>, action: timeCardPunch }, 
                { path: "UpdateTime", element: <Outlet/>, action: timeCardUpdateTime }, 
                { path: "UpdateContent", element: <Outlet/>, action: timeCardUpdateContent }, 
                { path: "Submit", element: <Outlet/>, action: timeCardSubmit }, 
                { path: "Download", element: <Outlet/>, action: timeCardDownload }, 
                { path: "*", element: <Navigate to = "/TimeCard" replace/> }, 
            ]}, 
            { path: "*", element: <Navigate to = ".." replace/> },
        ]
    },
    {
        show: user.allOffice !== "no",
        title: "All Time Card",
        img: timecardimg,
        path: "AllTimeCards",
        children: [
            {
                path: ":week?",
                children: [
                    { index: true, element: <AllTimeCardsList />, loader: allTimeCardsListLoader },
                    { path: "Export", element: <Outlet/>, action: timeCardExportAction }, 
                    {
                        path: ":userId",
                        element: <AllTimeCardsDetail />,
                        loader: allTimeCardsDetailLoader,
                        children: [
                            { path: "UpdateTime",    element: <Outlet />, action: allTimeCardsUpdateTimeAction },
                            { path: "Approval",       element: <Outlet />, action: allTimeCardsApprovalAction },
                            { path: "Submit",        element: <Outlet />, action: timeCardSubmit },
                            { path: "Download",      element: <Outlet />, action: timeCardDownload },
                            { path: "*",             element: <Navigate to = ".." replace /> },
                        ],
                    },
                ],
            },
            { path: "*", element: <Navigate to=".." replace /> },
        ],
    },
    {
        show: user.personel !== "no", 
        title: "Users", 
        path: "Users", 
        img: personelimg, 
        children: [
            { 
                path: "", 
                element: <UserList/>, 
                loader: usersLoader,
                id: "userList",
                children:[
                    {path: "Export", element: <UserExportForm/>, children: [{path: "Execute", element: <Outlet/>, action: userExportAction}]},
                    {path: "Birthday", element: <BirthDayForm/>},
                    {path: "Filter", element: <UsersFilterForm/>},
                ]
            }, 
            { 
                id: "user", 
                path: ":id", 
                loader: userLoader, 
                children: [
                    { index : true, element : <UserDetail/>}, 
                    { path: "Edit", element: <UserForm keyword = "Edit"/>, action: userAction}, 
                    { path: "*", element: <Navigate to = ".." replace/>},
                    { path: "Delete", element: <Outlet/>, action: deleteUserAction}, 
                    { path: "Void", element: <Outlet/>, action: voidUserAction}, 
                    { path: "Validate", element: <Outlet/>, action: validateUserAction}, 
                ]
            },
            { path: "Add", element: <UserForm keyword = "Add"/>, action: userAction}, 
            { path: "*", element: <Navigate to = ".." replace/>}
        ]
    }, 
];
export default appRoutes;
